module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_jaw.17f9481e.png";